import React, { createContext, useContext, useState } from "react";
import { DEFAULT_LOCALE } from "./constants";

type ActiveLocaleContextValue = {
  activeLocale: string;
  setActiveLocale: (locale: string) => void;
};

const ActiveLocaleContext = createContext<ActiveLocaleContextValue>({
  activeLocale: DEFAULT_LOCALE,
  setActiveLocale: () => {},
});

export const ActiveLocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeLocale, setActiveLocale] = useState(DEFAULT_LOCALE);
  return (
    <ActiveLocaleContext.Provider value={{ activeLocale, setActiveLocale }}>
      {children}
    </ActiveLocaleContext.Provider>
  );
};

export const useActiveLocale = () => useContext(ActiveLocaleContext);
